import { getContext } from "svelte";

export const hostContextKey = "__oc_host__";

/**
 *
 *
 *
 *
 *
 */
export const useHost = <Host extends HTMLElement>(): Host =>
  (getContext(hostContextKey) as Host) ??
  (() => {
    throw new Error(
      "Host element is not set. Ensure that the component is properly initialized and the host is set before using this function.",
    );
  })();
